module.exports = __webpack_public_path__ + "img/gedung.39bc684a.png";